import axios from "@/axios";
import {Module} from "vuex";
import { sortByName } from "@/utils/sortGeography";

const state = () => ({
    states: [],
    blogStates: []
});

const getters = {
    getStates(state: any){
        return state.states;
    },
    getBlogStates(state:any){
        return state.blogStates;
    }
};
const actions = {
    async fetchStates({commit}: any, countryId: any){
        const response = await axios.get('/state/'+countryId);
        commit('saveStates', response.data);
    },
    async fetchBlogStates({commit}: any, countryId: any){
        const response = await axios.get('/blog/state/'+countryId);
        commit('saveBlogStates', response.data);
    }
};
const mutations = {
    saveStates(state: any, payload: any){
        state.states = sortByName(payload);
        localStorage.setItem('states',JSON.stringify(state.states))
    },
    saveBlogStates(state: any, payload: any){
        state.blogStates = sortByName(payload);
        localStorage.setItem('blogStates',JSON.stringify(state.blogStates))
    }
};

export const states: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}